<template>
  <v-overlay>
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "ConfirmEmail",
  beforeCreate() {
    if (this.$route.query.code) {
      this.$store
        .dispatch("profileStore/confirmEmail", { code: this.$route.query.code })
        .finally(() => {
          this.$router.push("/");
        });
    } else {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped></style>
